<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-inputNumber style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="12">
                    <a-form-item label="需求类型" name="demandType">
                        <a-inputNumber style="width:100%" v-model:value="form.demandType" placeholder="请输入需求类型" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="需求内容" name="demandContent">
                        <a-inputNumber style="width:100%" v-model:value="form.demandContent" placeholder="请输入需求内容" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人" name="contacts">
                        <a-inputNumber style="width:100%" v-model:value="form.contacts" placeholder="请输入联系人" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="contactNumber">
                        <a-inputNumber style="width:100%" v-model:value="form.contactNumber" placeholder="请输入联系电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="需求状态" name="demandStatus">
                        <a-inputNumber style="width:100%" v-model:value="form.demandStatus" placeholder="请输入需求状态" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="备注" name="remark">
                        <a-inputNumber style="width:100%" v-model:value="form.remark" placeholder="请输入备注" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeDemandReply} from "@/api/finance";
import {innovation} from "@/config/variableConfig";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                    companyCode: null,
                    demandType: null,
                    demandContent: null,
                    contacts: null,
                    contactNumber: null,
                    demandStatus: null,
                    remark: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    demandType: [dataCheck.required({type:'number'})],
                    demandContent: [dataCheck.required({type:'number'})],
                    contacts: [dataCheck.required({type:'number'})],
                    contactNumber: [dataCheck.required({type:'number'})],
                    demandStatus: [dataCheck.required({type:'number'})],
                    remark: [dataCheck.required({type:'number'})],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeDemandReply.edit
                } else {
                    return financeDemandReply.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
